var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "p-0 pl-1 m-0",
      class: { "col-12": _vm.$window.isSP, "col-2": _vm.$window.isPC }
    },
    [
      _vm.$window.isSP
        ? _c("div", [
            _vm.title
              ? _c(
                  "span",
                  { staticClass: "pt-3", staticStyle: { float: "left" } },
                  [_c("h3", [_vm._v(_vm._s(_vm.title))])]
                )
              : _vm._e(),
            _vm._v(" "),
            _c(
              "button",
              {
                staticClass: "btn mt-2 btn-outline-dark",
                staticStyle: { float: "right" },
                on: {
                  click: function($event) {
                    $event.stopPropagation()
                    return _vm.clickShowMenu($event)
                  }
                }
              },
              [
                _c("i", { staticClass: "fa fa-user" }),
                _vm._v("ユーザ情報\n      ")
              ]
            )
          ])
        : _vm._e(),
      _vm._v(" "),
      _c("transition", [
        _c(
          "div",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.$window.isPC || _vm.showMenu,
                expression: "($window.isPC) || showMenu"
              }
            ],
            class: {
              accordion: _vm.$window.isSm || _vm.$window.isXs,
              open: _vm.showMenu
            },
            on: {
              click: function($event) {
                $event.stopPropagation()
              }
            }
          },
          [
            _c("nav", [
              _c("ul", { staticClass: "nav nav-pills flex-column" }, [
                _c(
                  "li",
                  { staticClass: "nav-item pt-2 pb-2 mb-2 name-label" },
                  [_c("h5", [_vm._v(_vm._s(_vm.user.userName))])]
                )
              ]),
              _vm._v(" "),
              _c("ul", { staticClass: "nav nav-pills flex-column" }, [
                _c("li", { staticClass: "nav-item" }, [
                  _c("p", { staticClass: "side-label" }, [
                    _c("i", { staticClass: "fa fa-calendar ml-1 mr-1" }),
                    _vm._v("入社日")
                  ]),
                  _vm._v(" "),
                  _vm.user.hireDate
                    ? _c("p", [
                        _vm._v(_vm._s(_vm._f("datetime")(_vm.user.hireDate)))
                      ])
                    : _c("p", [_vm._v("未設定")])
                ]),
                _vm._v(" "),
                _c("li", { staticClass: "nav-item" }, [
                  _c("p", { staticClass: "side-label" }, [
                    _c("i", { staticClass: "fa fa-building ml-1 mr-1" }),
                    _vm._v("所属")
                  ]),
                  _vm._v(" "),
                  _vm.user.unit
                    ? _c("p", [_vm._v(_vm._s(_vm.user.unit))])
                    : _c("p", [_vm._v("未設定")])
                ]),
                _vm._v(" "),
                _c("li", { staticClass: "nav-item" }, [
                  _c("p", { staticClass: "side-label" }, [
                    _c("i", { staticClass: "fa fa-clipboard ml-1 mr-1" }),
                    _vm._v("シフト")
                  ]),
                  _vm._v(" "),
                  _vm.user.shiftName
                    ? _c("p", [_vm._v(_vm._s(_vm.user.shiftName))])
                    : _c("p", [_vm._v("未設定")])
                ]),
                _vm._v(" "),
                _c("li", { staticClass: "nav-item" }, [
                  _c("p", { staticClass: "side-label" }, [
                    _c("i", { staticClass: "fa fa-clock ml-1 mr-1" }),
                    _vm._v(
                      _vm._s(_vm._f("monthBy2digit")(_vm.month)) +
                        "の労働時間(" +
                        _vm._s(_vm.user.workStartDate) +
                        "日始)"
                    )
                  ]),
                  _vm._v(" "),
                  _c("p", [
                    _c("span", [
                      _vm._v(
                        _vm._s(_vm.user.workHourSum) +
                          "（" +
                          _vm._s(_vm.user.workCount) +
                          "日）"
                      )
                    ])
                  ])
                ]),
                _vm._v(" "),
                _c("li", { staticClass: "nav-item" }, [
                  _c("p", { staticClass: "side-label" }, [
                    _c("i", { staticClass: "fa fa-yen-sign ml-1 mr-1" }),
                    _vm._v(
                      _vm._s(_vm._f("monthBy2digit")(_vm.month)) + "の交通費"
                    )
                  ]),
                  _vm._v(" "),
                  _c("p", [
                    _c("span", [
                      _vm._v(_vm._s(_vm._f("separate")(_vm.user.kotsuhiSum)))
                    ]),
                    _vm._v("円")
                  ])
                ]),
                _vm._v(" "),
                _c("li", { staticClass: "nav-item" }, [
                  _c("p", { staticClass: "side-label" }, [
                    _c("i", { staticClass: "fa fa-gift ml-1 mr-1" }),
                    _vm._v("有給残日数")
                  ]),
                  _vm._v(" "),
                  _c("p", [
                    _vm.user.yukyuStartDate
                      ? _c("span", [
                          _c("div", [
                            _vm._v(
                              _vm._s(_vm.user.yukyuReamingDays) +
                                "日(次回" +
                                _vm._s(
                                  _vm._f("next")(_vm.user.yukyuStartDate)
                                ) +
                                "付与)"
                            )
                          ]),
                          _vm._v(" "),
                          _c("div", [
                            _vm._v("内訳: \n                              "),
                            _c(
                              "div",
                              { staticStyle: { "text-indent": "1em" } },
                              [
                                _vm._v(
                                  "前年度残: " +
                                    _vm._s(_vm.user.yukyuPreReamingDays) +
                                    "日"
                                )
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "div",
                              { staticStyle: { "text-indent": "1em" } },
                              [
                                _vm._v(
                                  "今年度残: " +
                                    _vm._s(
                                      _vm.user.yukyuReamingDays -
                                        _vm.user.yukyuPreReamingDays
                                    ) +
                                    "日"
                                )
                              ]
                            )
                          ])
                        ])
                      : _c("span", [_vm._v("有給付与なし")])
                  ])
                ])
              ])
            ])
          ]
        )
      ])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-6737c34a", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6737c34a","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/assets/js/components/operator/SideMenu.vue
// module id = 500
// module chunks = 0